import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AppScope} from '../../../services/app_scope.service';
import {COMMON_FORM_IMPORTS} from "../../../shared/import-groups/Common";
import {ColourPaletteComponent} from "../../colour_palette";
import {CdkDrag} from "@angular/cdk/drag-drop";
import {RemoveUnderscorePipe} from "../../../shared/pipes";
import {CommonModule} from "@angular/common";

export interface ConfigType {
    selected_model: any;
    origin: any;
    original_models: any;
    font_size: number;
    menu_visible: boolean;
}

@Component({
    selector: 'series-summary-menu',
    templateUrl: './series-summary-menu.component.html',
    styleUrls: ['./series-summary-menu.component.less'],
    imports: [
        CommonModule,
        ColourPaletteComponent,
        COMMON_FORM_IMPORTS,
        CdkDrag,
        RemoveUnderscorePipe
    ],
    encapsulation: ViewEncapsulation.None
})
export class SeriesSummaryMenuComponent implements OnInit {
    @Output() paramsChanged = new EventEmitter();
    draggable = true;

    constructor(private appScope: AppScope) {
    }

    private _config: ConfigType;

    get config(): ConfigType {
        return this._config
    }

    @Input()
    set config(config: ConfigType) {
        this._config = config;
        if (config) {
        }
    }

    ngOnInit(): void {
    }

    setFontSize(event) {
        this.paramsChanged.emit({style: 'font-size', event: this.config.font_size});
    }

    setStyle(event, style) {
        this.paramsChanged.emit({style: style, event: event});
    }
}
